import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardListaVagas: {
    minHeight: 460,
    maxHeight: 460
  },
  listaVagas: {
    maxHeight: 340,
    minHeight: 340,
    overflow: 'auto'
  },
});

export default function ListaVagas(props) {

  const classes = useStyles();

  const detalhesListaVagas = props.detalhesListaVagas;

  let itensVagas = [];

  detalhesListaVagas.forEach((vaga, indice) => {
    let titulo = vaga.vaga;
    let qtdCandidatos = vaga.qtd_candidatos;
    let textoQtd;

    if (qtdCandidatos === 0) { textoQtd = "Não há candidatos" }
    else if (qtdCandidatos === 1) { textoQtd = qtdCandidatos + " Candidato"; }
    else { textoQtd = qtdCandidatos + " Candidatos"; }

    itensVagas.push(
      <ListItem
        key={indice}>
        <ListItemText primary={titulo} secondary={textoQtd} />
      </ListItem>
    );
  })

  return (
    <Card className={classes.cardListaVagas}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Lista de Vagas
          </Typography>
        <List className={classes.listaVagas}>
          {itensVagas}
        </List>
      </CardContent>
      <CardActions>
        <Button size="small" color="primary" href={'/gerenciar-vagas'}>
          Gerenciar
        </Button>
      </CardActions>
    </Card>
  );
}